import { isNull } from 'utils/tsHelpers';
import { useModalContext } from 'utils/contexts/modal';
import { LinkTarget } from '../types';
import { useInsertNewHyperlink } from './useInsertNewHyperlink';
import { useUpdateExistingHyperlink } from './useUpdateExistingHyperlink';
import { useSelectedHyperlink } from '../../hooks/useSelectedHyperlink';
import { useEditorContext } from '../../contexts/editor';

export const useSetHyperlink = () => {
  const { editor } = useEditorContext();
  const { hideModal } = useModalContext();
  const selectedHyperlink = useSelectedHyperlink();
  const insertNewHyperlink = useInsertNewHyperlink();
  const updateExistingHyperlink = useUpdateExistingHyperlink();
  return (displayText: string, href: string, target: LinkTarget) => {
    if (!isNull(selectedHyperlink)) updateExistingHyperlink(displayText, href, target);
    else insertNewHyperlink(displayText, href, target);
    hideModal();
    editor?.focus();
  };
};
